export const NAME = 'name' as const;

export type SortField = typeof NAME;

const sortFields = [NAME];

export default sortFields;
